import { AutoScroll } from 'components/blocks/AutoScroll';
import { NextLinkTr } from 'components/blocks/NextLink';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { BlockHeader } from 'components/blocks/BlockHeader';
import { BlockContent } from 'components/blocks/BlockContent';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { Routes } from 'routes';
import { IResortPathInfo, ISnowHistoryItem } from 'api/resort/types';
import {
  SnowCardTdDate, SnowCardTdSnow, SnowCardTh,
} from 'components/resort/ForecastedSnow/SnowCard';
import styles from './styles.module.scss';

interface IForecastedSnowProps {
  resort: IResortPathInfo,
  isFresh: boolean,
  data: Array<ISnowHistoryItem>,
  isMetricUnits: boolean
}

export const ForecastedSnow = ({
  resort, data, isFresh, isMetricUnits,
}: IForecastedSnowProps) => {
  const { t } = useOTSTranslation('common');
  return (
    <BoxWithShadow>
      <BlockHeader useH3 title={t('resort.skiReport.forecastedSnow')}>
        <NextLinkTr href={Routes.resortWeather(resort)} scroll>
          {t('resort.skiReport.fullWeatherForecast')}
        </NextLinkTr>
      </BlockHeader>
      <BlockContent blur={!isFresh}>
        <div className={styles.wrapper}>
          <AutoScroll>
            <table className={styles.box}>
              <thead>
                <tr>
                  {data.map((d) => (
                    <SnowCardTh
                      key={d.date}
                      date={d.date}
                      snow={d.snow}
                    />
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {data.map((d) => (
                    <SnowCardTdSnow
                      key={d.date}
                      date={d.date}
                      snow={d.snow}
                      isMetricUnits={isMetricUnits}
                    />
                  ))}
                </tr>

                <tr>
                  {data.map((d) => (
                    <SnowCardTdDate
                      key={d.date}
                      date={d.date}
                      snow={d.snow}
                    />
                  ))}
                </tr>

              </tbody>
            </table>
          </AutoScroll>
        </div>
      </BlockContent>
    </BoxWithShadow>
  );
};
